import { API_BASE_URL } from '@synergy/config';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch } from '../../store/store';
import { CategoriesApi } from '../api/categories-api';
import { CategoryDto } from '../models/dto/category-dto';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { enqueueSnackbar } from './snackbar-actions';

const api = new CategoriesApi(API_BASE_URL);

export const categoriesLoaded = createAction<CategoryDto[]>('configuration/categories-loaded');

export const fetchCategories = (categoryId?: number) => async (dispatch: AppDispatch) => {
    const response = await api.getCategories(categoryId);
    if (response.success) {
        dispatch(categoriesLoaded(response.result));
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};
